// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".backdrop-filter{backface-visibility:hidden}@supports((-webkit-backdrop-filter:none) or (backdrop-filter:none)){.backdrop-filter{-webkit-backdrop-filter:blur(20px);backdrop-filter:blur(20px)}}.backdrop-filter.bg-gray,.backdrop-filter.bg-gray:hover{background-color:#ccc}@supports((-webkit-backdrop-filter:none) or (backdrop-filter:none)){.backdrop-filter.bg-gray,.backdrop-filter.bg-gray:hover{background-color:hsla(0,0%,100%,.1)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
